require('./bootstrap');
require('slick-carousel');
require("fslightbox");

import RoostHomeSlider from "./modules/RoostHomeSlider";
import RoostGallery from "./modules/RoostGallery";

var homeSlider = new RoostHomeSlider();
var gallery = new RoostGallery();
